
import { Options, Vue } from 'vue-class-component';

@Options({
	name: 'SmallLoader',
	components: {},
})
export default class SmallLoader extends Vue {}
